export const CONTAINS_ONLY_CHARS_REGEX = /^\s*\S[\s\S]*$/;
export const INPUT_CHAR_MIN = 2;
export const INPUT_CHAR_MAX = 40;
export const MESSAGE_CHAR_LIMIT = 2000;
